var skills = {
    languages: ['Python', 'Java', 'C#', 'SQL', 'JavaScript', 'HTML/CSS', 'S3'],
    techniques: ['ollama', 'Amazon Bedrock', 'LangChain', 'PyTorch', 'TensorFlow', 'scikit-learn', 'pandas'],
    research: ['In-Depth Interviews', 'Surveys', 'Thematic Analysis', 'Inferential and Predictive Statistics', 'Interface Analysis'],
};

export default skills;